import { Component, OnInit } from '@angular/core';
import { HydroStormService, SharedService } from './../../../services';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'hydro-storm',
  templateUrl: './hydro-storm.component.html',
  styleUrls: ['./hydro-storm.component.scss'],
  host: {
    "(click)": "goToDetails()"
  }
})
export class HydroStormComponent implements OnInit {

  constructor(
    private _storm: HydroStormService,
    private _sanitizer: DomSanitizer,
    private _router: Router,
    private _shared: SharedService
  ) { }

  loading = false;
  data;

  getTrueText(html) {
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  checkAllDate(data) {
    let isStorm = data.some(v => new Date(v.end_date) > new Date());
    this._shared.changeHydroStormWidget(isStorm);
    return isStorm;
  }

  goToDetails() {
    this._router.navigate(['/observation/hydrology']);
  }

  getCurrent() {
    this.loading = true;
    this._storm.getCurrent().subscribe(
      res => {
        this.data = res;
        if (res && res.length && res.length > 0) {
          this._shared.changeHydroStormWidget(true);
        } else {
          this._shared.changeHydroStormWidget(false);
        }
        this.loading = false;
      },
      err => {
        console.error(err);
        this._shared.changeHydroStormWidget(false);
        this.loading = false;
      }
    )
  }

  ngOnInit() {
    this.getCurrent();
  }


}
